export default "__VITE_ASSET__nGs84J5b__"